// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/components/style/global.scss'
// 面包屑
import HBreadcrumb from '@/components/view/common/HBreadcrumb.vue'
Vue.component('HBreadcrumb', HBreadcrumb)

import global_ from './global'
import axios from './axiosUtils'  

Vue.prototype.$axios = axios
Vue.prototype.$global = global_

Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js